function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.29998 4.39998V3.94284C3.29998 2.42338 4.50426 1.19998 5.99998 1.19998C7.49569 1.19998 8.69998 2.42338 8.69998 3.94284V4.39998M3.29998 4.39998C2.80498 4.39998 2.39998 4.81141 2.39998 5.31427V9.88569C2.39998 10.3886 2.80498 10.8 3.29998 10.8H8.69998C9.19498 10.8 9.59998 10.3886 9.59998 9.88569V5.31427C9.59998 4.81141 9.19498 4.39998 8.69998 4.39998M3.29998 4.39998H8.69998M5.99998 8.09998V6.89998",
    stroke: "#8B8A9E",
    style: {
      stroke: "#8B8A9E",
      stroke: "color(display-p3 0.5451 0.5412 0.6196)",
      strokeOpacity: 1
    },
    strokeLinecap: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.6f7bd0cd29d9ab1e2074fe87b50dd283.svg";
export { ForwardRef as ReactComponent };